import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55c0cb0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timer" }
const _hoisted_2 = { class: "recap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "spartan-font text-lg" }, "Today's recap", -1))
const _hoisted_4 = {
  key: 0,
  class: "spartan-font text-base"
}
const _hoisted_5 = { class: "total" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "spartan-font text-lg" }, "Today's total", -1))
const _hoisted_7 = {
  key: 0,
  class: "spartan-font text-base"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "study" }, "Studied", -1))
const _hoisted_9 = {
  key: 1,
  class: "spartan-font text-base"
}
const _hoisted_10 = {
  key: 2,
  class: "spartan-font text-base"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "rest" }, "Rested", -1))
const _hoisted_12 = {
  key: 3,
  class: "spartan-font text-base"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historyStore.recaps, (recap, index) => {
        return (_openBlock(), _createElementBlock("p", {
          class: "spartan-font text-base",
          key: index
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(recap.type)
          }, _toDisplayString(_ctx.formatDate(recap.at)) + " " + _toDisplayString(recap.type === ('study' as string) ? 'Studied' : 'Rested'), 3),
          _createTextVNode(" for " + _toDisplayString(_ctx.formatDuration(recap.for)), 1)
        ]))
      }), 128)),
      (!_ctx.historyStore.recaps[0])
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Let's get started "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      (_ctx.historyStore.total.study)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
            _hoisted_8,
            _createTextVNode(" for " + _toDisplayString(_ctx.formatDuration(_ctx.historyStore.total.study)), 1)
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_9, "You should work you know ?")),
      (_ctx.historyStore.total.rest)
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
            _hoisted_11,
            _createTextVNode(" for " + _toDisplayString(_ctx.formatDuration(_ctx.historyStore.total.rest)), 1)
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_12, "You may need a break !"))
    ])
  ]))
}